import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  const location = useLocation();
  const { pathname, search } = location;
  const fullPath = pathname + search;

  useEffect(() => {
    if (pathname.startsWith("/game/mutelu") || pathname.startsWith("/game/ticket")) {
      return;
    }

    // /BigC_Exhibition (ไม่ระบุจังหวัด) redirect ไป /BigC_Exhibition/<ถุงเริ่มต้น> ทันที — ไม่นับ page view ซ้ำ
    if (/^\/bigc_exhibition\/?$/i.test(pathname)) {
      return;
    }

    //console.log("Tracking page:", pathname); // ✅ ต้องแสดงทุกครั้งที่เปลี่ยนหน้า
    const pageNameMap = [
      ["/my-coupons", "My Coupons"],
      ["/bc-coupons", "All Coupons"],
      ["/promotion", "Promotion"],
      ["/catalog", "E-Catalog"],
      ["/campaign", "Campaign"],
      ["/blogs", "Blogs"],
      ["/horoscope", "Horoscope"],
      ["/missions", "Mission"],
      ["/my-bigpoint", "My Bigpoint"],
      ["/register", "Register"],
      ["/login", "Login"],
      ["/survey", "Survey"],
      ["/line-sticker", "Line Sticker"],
      ["/game", "Gamification"],
      ["/BigC_Exhibition", "BigC Exhibition"],
      ["/", "Home"],
    ];

    const matched = pageNameMap.find(([prefix]) => pathname.startsWith(prefix));
    //console.log("matched = ", matched);

    const pageTitle = matched
      ? `${matched[1]} | ${process.env.REACT_APP_NAME}`
      : process.env.REACT_APP_NAME;

    document.title = pageTitle;

    //console.log("PageTitle = ", pageTitle);

    if (window.gtag) {
      window.gtag("config", "G-5GQZ82PHTN", {
        page_path: fullPath,
        page_title: pageTitle,
      });
    }

    if (window.fbq) {
      window.fbq("track", "PageView");
    }

    // Debug log (ลบได้ใน production)
    // console.log("Set title:", pageTitle);
  }, [pathname]);
};

export default usePageTracking;
